import { defineStore } from 'pinia';
import { loadSellerIndexData } from '@/api/seller';
import { useUserStore } from '@/store';

interface SellerHomeState {
  goods: {
    goodsCount: number
    colShopCount: number
    newGoodsCount: number
    clickGoodsCount: number
  }
  sale: {
    saleNum: number
    refundNum: number
    refundRate: string
  }
  point: {
    scope: number
    scopeSort: number
    scopeLv: number
    lastUserScope: number
    lastLvScope: number
    baseScope: number
    photoScope: number
    saleScope: number
    profitScope: number
    lackScope: number
    noorderScope: number
    pickErrorScope: number
    lateScope: number
  }
  booth: {
    isOnly: boolean
    isUpLicense: boolean
    isBuyCS: boolean
  }
  upList: Array<{ pt_id: number, pic_url: string, pt: string, num: number }>
  sellerSite: {
    url: string
    urlQrcode: string
  }
}

export const useSellerHome = defineStore({
  id: 'seller-home',
  state: (): SellerHomeState => ({
    goods: {
      goodsCount: 0,
      colShopCount: 0,
      newGoodsCount: 0,
      clickGoodsCount: 0,
    },
    sale: {
      saleNum: 0,
      refundNum: 0,
      refundRate: '',
    },
    point: {
      scope: 0,
      scopeSort: 0,
      scopeLv: 0,
      lastUserScope: 0,
      lastLvScope: 0,
      baseScope: 0,
      photoScope: 0,
      saleScope: 0,
      profitScope: 0,
      lackScope: 0,
      noorderScope: 0,
      pickErrorScope: 0,
      lateScope: 0,
    },
    upList: [],
    booth: {
      isOnly: false,
      isUpLicense: false,
      isBuyCS: false,
    },
    sellerSite: {
      url: '',
      urlQrcode: '',
    },
  }),
  getters: {
    lvText(): string {
      if (this.point.scopeLv === 0) return '普通';
      if (this.point.scopeLv === 1) return '钻石';
      if (this.point.scopeLv === 2) return '星耀';
      if (this.point.scopeLv === 3) return '王者';
      return '--';
    },
  },
  actions: {
    async getBoothHomeData() {
      const userStore = useUserStore();
      const res = await loadSellerIndexData(userStore?.userInfo?.sellerSiteInfo?.code);
      this.goods.goodsCount = res.goods_count;
      this.goods.newGoodsCount = res.new_goods_count;
      this.goods.colShopCount = res.col_shop_count;
      this.goods.clickGoodsCount = res.click_goods_count;
      this.sale.saleNum = res.scope.sale_num;
      this.sale.refundNum = res.scope.refund_num;
      this.sale.refundRate = res.scope.refund_rate;
      this.upList = res.total_up_list;
      this.point.scope = res.scope.scope;
      this.point.scopeSort = res.scope.scope_sort;
      this.point.scopeLv = res.scope.scope_lv;
      this.point.lastUserScope = res.scope.sj_scope;
      this.point.lastLvScope = res.scope.sj_lv_scope;
      this.point.baseScope = res.scope.base_scope;
      this.point.photoScope = res.scope.photo_scope;
      this.point.saleScope = res.scope.sale_scope;
      this.point.profitScope = res.scope.profit_scope;
      this.point.lackScope = res.scope.lack_scope;
      this.point.noorderScope = res.scope.noorder_scope;
      this.point.pickErrorScope = res.scope.pick_error_scope;
      this.point.lateScope = res.scope.late_scope;
      this.booth.isOnly = res.scope.is_only === 1;
      this.booth.isUpLicense = res.scope.is_up_license === 2;
      this.booth.isBuyCS = res.scope.is_buy_cs === 1;
      this.sellerSite.url = res.seller_site_url;
      this.sellerSite.urlQrcode = res.seller_site_url_qrcode;
    },
  },
});
